import Config from './config/config';
export const prefix = '';
export const assetsPrefix = Config.assetsPrefix;
export const host = Config.host;
export const apiUrl = Config.apiUrl;
export const formTypes = {
	urlencoded: 'application/x-www-form-urlencoded',
	json: 'application/json'
}
